import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingAlignCenter: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h16v4H0zm2 6h12v4H2zm14 6H0v4h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingAlignCenter
